import { Button, IconButton, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";

import { User } from "../../models/User.model";
import { ActionHistory } from "../../types/ActionHistory";
import { Customer } from "../../types/Customer";
import { Quotation } from "../../types/Quotation";
import DynamicIcon from "../Icons/DynamicIcon";
import PopinQuotationActions from "../PopinQuotationActions/PopinQuotationActions";
import { styles } from "./QuotationActions.style";

interface QuotationActionsProps extends WithStyles<typeof styles> {
    advisor: User;
    customer: Customer;
    quotation: Quotation;
    buttonOnly?: boolean;
    onActionPerformed(quotation: Quotation, actionHistory: ActionHistory);
}

interface QuotationActionsState {
    action: string;
}

const buttons = [
    { icon: "download", label: "Télécharger", action: "download" },
    { icon: "print", label: "Imprimer", action: "print" },
    { icon: "send", label: "Envoyer", action: "send", disabled: (customer: Customer) => !customer.email },
];

class QuotationActions extends React.Component<QuotationActionsProps, QuotationActionsState> {
    state: QuotationActionsState = {
        action: null,
    };

    public render() {
        const { classes, theme } = this.props;
        return (
            <>
                {this.state.action && (
                    <PopinQuotationActions
                        onActionPerformed={this.props.onActionPerformed}
                        open={this.state.action != null}
                        action={this.state.action}
                        advisor={this.props.advisor}
                        customer={this.props.customer}
                        quotation={this.props.quotation}
                        onSuccess={() => this.reset()}
                        onCancel={() => this.reset()}
                    />
                )}
                {buttons.map(
                    (button) =>
                        this.props.buttonOnly ? (
                            <IconButton
                                onClick={() => this.onActionClick(button.action)}
                                className={classes.button}
                                type="submit"
                                color="default"
                                disabled={button.disabled && button.disabled(this.props.customer)}
                                key={button.icon}
                            >
                                <DynamicIcon name={button.icon} nativeColor={theme.palette.primary.main} />
                            </IconButton>
                        ) : (
                            <Button
                                onClick={() => this.onActionClick(button.action)}
                                type="submit"
                                color="default"
                                size="small"
                                disabled={button.disabled && button.disabled(this.props.customer)}
                                key={button.icon}
                            >
                                <DynamicIcon name={button.icon} nativeColor={theme.palette.primary.main} size={16} />
                                <span className={classes.buttonLabel}>{button.label}</span>
                            </Button>
                        )
                )}
            </>
        );
    }

    private onActionClick(action: string) {
        this.setState({ action: action });
    }

    private reset() {
        this.setState({ action: null });
    }
}

export default withStyles(styles, { withTheme: true })(QuotationActions);



// WEBPACK FOOTER //
// ./src/components/QuotationActions/QuotationActions.tsx